import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Glass extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  GetAllSpacer(params) {
    return this.httpService.get("Definition/all-spicer", { headers, params });
  }

  insertSpacer(data) {
    return this.httpService.post("Definition/insert-Spicer", data, { headers });
  }

  deleteSpacer(data) {
    return this.httpService.delete("Definition/delete-spicer", {
      headers,
      data,
    });
  }

  getRelationSpacer(params) {
    return this.httpService.get("Definition/relation-spicer", {
      headers,
      params,
    });
  }

  GetAllShishe(params) {
    return this.httpService.get("Definition/all-glass", { headers, params });
  }

  insertShishe(data) {
    return this.httpService.post("Definition/insert-glass", data, { headers });
  }

  deleteShishe(data) {
    return this.httpService.delete("Definition/delete-glass", {
      headers,
      data,
    });
  }
  editShishe(data) {
    return this.httpService.put("Definition/update-glass", data, {
      headers,
    });
  }

  getRelationShishe(params) {
    return this.httpService.get("Definition/relation-glass", {
      headers,
      params,
    });
  }

  GetAllShisheGroup(params) {
    return this.httpService.get("Definition/all-group-glass", {
      headers,
      params,
    });
  }
  editShisheGroup(data) {
    return this.httpService.put("Definition/update-group-glass", data, {
      headers,
    });
  }

  insertShisheGroup(data) {
    return this.httpService.post("Definition/insert-group-glass", data, {
      headers,
    });
  }

  deleteShisheGroup(data) {
    return this.httpService.delete("Definition/delete-group-glass", {
      headers,
      data,
    });
  }

  getRelationShisheGroup(params) {
    return this.httpService.get("Definition/relation-group-glass", {
      headers,
      params,
    });
  }

  GetAllMahsooleShishe(params) {
    return this.httpService.get("Definition/all-product-glass", {
      headers,
      params,
    });
  }

  getGroupProductGlass(params) {
    return this.httpService.get("Definition/combo-group-product-glass", {
      headers,
      params,
    });
  }

  getJedareList(params) {
    return this.httpService.get("Definition/combo-wall-glass", {
      headers,
      params,
    });
  }

  getGlassList(params) {
    return this.httpService.get("Definition/combo-price-glass", {
      headers,
      params,
    });
  }

  getSpacerList(params) {
    return this.httpService.get("Definition/combo-price-spicer", {
      headers,
      params,
    });
  }
  editSpacer(data) {
    return this.httpService.put("Definition/update-Spicer", data, {
      headers,
    });
  }

  InsertMahsooleShisheData(data) {
    return this.httpService.post("Definition/insert-product-glass", data, {
      headers,
    });
  }

  EditPriceMahsooleShishe(data) {
    return this.httpService.put("Definition/set-price-product-glass", data, {
      headers,
    });
  }

  GetEditMahsooleShisheData(params) {
    return this.httpService.get("Definition/select-product-glass", {
      headers,
      params,
    });
  }

  editMahsooleShisheData(data) {
    return this.httpService.put("Definition/update-product-glass", data, {
      headers,
    });
  }

  LightEditData(data) {
    return this.httpService.put(
      "Definition/Update-price-name-product-glass",
      data,
      { headers }
    );
  }

  deleteMahsooleShishe(data) {
    return this.httpService.delete("Definition/delete-product-glass", {
      headers,
      data,
    });
  }

  getRelationMahsooleShishe(params) {
    return this.httpService.get("Definition/relation-product-glass-unit", {
      headers,
      params,
    });
  }

  changePriceProductGlassGroup(data) {
    return this.httpService.put(
      "Definition/set-price-product-glass-group",
      data,
      { headers }
    );
  }

  disableMahSooleShishe(data) {
    return this.httpService.put("Definition/disable-product-glass", data, {
      headers,
    });
  }

  disableShisheGroup(data) {
    return this.httpService.put("Definition/disable-group-glass", data, {
      headers,
    });
  }

  disableShishe(data) {
    return this.httpService.put("Definition/disable-glass", data, { headers });
  }

  disableSpacer(data) {
    return this.httpService.put("Definition/disable-spicer", data, { headers });
  }
  getColorMahsooleShishe(params) {
    return this.httpService.get("Definition/color-pattern-drawer-glass", {
      headers,
      params,
    });
  }
}

const GlassService = new Glass();
export default GlassService;
